var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col lg:flex-row\n  justify-center lg:justify-between\n  lg:items-stretch items-center\n  text-left w-full\n  mt-14 mb-20 mx-auto\n  space-y-6 lg:space-y-0\n  service-card-wrapper\n"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }